<template>
  <div class="flex items-center justify-between" :style="{ color: color }">
    <template v-if="name">
      <div
        v-tooltip="!disableOpen ? t('canvasUI.CSavedCanvasesManagementUsedTemplateCell.clickToOpen') : undefined"
        class="truncate flex-1 min-w-0"
        :class="{ 'cursor-pointer': !disableOpen, underline: !disableOpen }"
        @click="handleOpen"
      >
        {{ name }}
      </div>
      <div
        v-if="!hideCreate"
        v-tooltip="t('canvasUI.CSavedCanvasesManagementUsedTemplateCell.createCanvasFromTemplate')"
        class="ml-1 cursor-pointer h-9 w-9 flex items-center justify-center flex-shrink-0"
        @click="emit('create')"
      >
        <CIcon :color="themeVars.primary2" fa-type="fa-kit" icon="solid-presentation-screen-circle-plus" size="18px" />
      </div>
    </template>
    <div v-else>
      {{ t('canvasUI.CSavedCanvasesManagementUsedTemplateCell.blankTemplate') }}
    </div>
  </div>
</template>

<script setup lang="ts">
import { useI18n } from 'vue-i18n'

import CIcon from '@lib/components/CIcon/CIcon.vue'
import useThemeVars from '@lib/composables/useThemeVars'
import tooltipDirective from '@lib/directives/tooltip'
import { computed } from 'vue'

const props = withDefaults(defineProps<{ name?: string; hideCreate?: boolean; disableOpen?: boolean }>(), {
  name: '',
  hideCreate: false,
})

const emit = defineEmits<{ open: []; create: [] }>()
const { t } = useI18n()
const themeVars = useThemeVars()
const vTooltip = tooltipDirective

const color = computed(() => {
  if (!props.name || props.disableOpen) {
    return themeVars.value.text3
  } else {
    return themeVars.value.primary
  }
})

function handleOpen() {
  if (props.disableOpen) return
  emit('open')
}
</script>
